export enum SimpleAnswer {
    NO, YES, UNKNOWN
}